import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';
import Header from '../components/dashboard/Header';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-[#F8F8F9] flex">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} isCollapsed={isCollapsed} />
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${isCollapsed ? 'lg:pl-20' : 'lg:pl-64'}`}>
        <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} isCollapsed={isCollapsed} toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-x-hidden">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
        <footer className="py-6 px-8 text-center text-xs font-semibold text-gray-400 border-t border-gray-100 bg-white">
          <div className="max-w-7xl mx-auto flex justify-center items-center w-full">
            ©2026 RM Ghana. All rights reserved. | <span className="text-brand-primary ml-1">Powered by Resource And Manpower</span>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DashboardLayout;